(function () {
  var FRAG = [
    'precision mediump float;',
    'uniform vec2 r;',
    'uniform float t;',
    'uniform float o;',
    'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
    'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.0-2.0*f);return mix(mix(h(i),h(i+vec2(1.0,0.0)),f.x),mix(h(i+vec2(0.0,1.0)),h(i+vec2(1.0,1.0)),f.x),f.y);}',
    'float fbm(vec2 p){float v=0.0,a=0.5;for(int i=0;i<6;i++){v+=a*n(p);p=mat2(1.6,1.2,-1.2,1.6)*p+vec2(1.7,9.2);a*=0.5;}return v;}',
    'float dens(vec2 p,float s){vec2 w=vec2(fbm(p*0.8+vec2(s*0.5,0.0)),fbm(p*0.8+vec2(5.2,1.3)-vec2(0.0,s*0.3)));float d=fbm(p+w*0.9+vec2(s,0.0));d-=0.08*fbm(p*5.0-vec2(s*2.0,0.0));return d;}',
    'void main(){',
    '  float yt=(r.y-gl_FragCoord.y)/300.0;',
    '  vec2 uv=vec2(gl_FragCoord.x/300.0,-yt);',
    '  float s=t*0.035;',
    '  float fold=1.0-smoothstep(1.0,2.2,yt);',
    '  vec3 top=vec3(0.56,0.74,0.82);',
    '  vec3 low=vec3(0.82,0.89,0.90);',
    '  vec3 col=mix(top,low,smoothstep(0.0,3.0,yt));',
    '  float df=dens(uv*1.2+vec2(3.0,0.0),s*0.5);',
    '  col=mix(col,vec3(0.88,0.93,0.95),smoothstep(0.42,0.72,df)*0.35);',
    '  vec2 p=uv*1.6+vec2(0.0,0.4);',
    '  float d=dens(p,s)+0.14*fold;',
    '  float c=smoothstep(0.50,0.63,d);',
    '  float lit=clamp((d-dens(p+vec2(0.0,-0.09),s)-0.14*fold)*4.0+0.6,0.0,1.0);',
    '  vec3 shade=vec3(0.72,0.80,0.85);',
    '  vec3 white=vec3(0.985,0.975,0.955);',
    '  vec3 warm=vec3(0.99,0.93,0.86);',
    '  vec3 cl=mix(shade,white,lit);',
    '  cl=mix(cl,warm,smoothstep(0.6,1.0,lit)*0.3*fold);',
    '  col=mix(col,cl,c);',
    '  gl_FragColor=vec4(col,1.0);',
    '}'
  ].join('\n');
  var VERT = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.0,1.0);}';
  var SCALE = 3;

  function start(canvas) {
    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, premultipliedAlpha: false, preserveDrawingBuffer: false });
    if (!gl) return;
    function sh(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
    }
    var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
    if (!vs || !fs) return;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs);
    gl.attachShader(prog, fs);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
    gl.useProgram(prog);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'p');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
    var uR = gl.getUniformLocation(prog, 'r'), uT = gl.getUniformLocation(prog, 't'), uO = gl.getUniformLocation(prog, 'o');
    var sky = canvas.parentElement, page = canvas.closest('.gene-page'), tail = 0;
    function reach() {
      if (!page) return;
      var groups = document.querySelectorAll('[class*="shopify-section-group-"][class*="footer"]');
      var bottom = page.getBoundingClientRect().bottom, end = bottom;
      for (var i = 0; i < groups.length; i++) end = Math.max(end, groups[i].getBoundingClientRect().bottom);
      var next = Math.max(0, Math.round(end - bottom));
      if (next === tail) return;
      tail = next;
      sky.style.setProperty('--gene-sky-tail', tail + 'px');
    }

    function size() {
      var w = Math.max(1, Math.ceil(canvas.clientWidth / SCALE));
      var hgt = Math.max(1, Math.ceil(canvas.clientHeight / SCALE));
      if (canvas.width !== w || canvas.height !== hgt) {
        canvas.width = w;
        canvas.height = hgt;
        gl.viewport(0, 0, w, hgt);
      }
      gl.uniform2f(uR, w, hgt);
      gl.uniform1f(uO, Math.min(tail / SCALE, hgt - 1));
    }
    var t0 = performance.now(), visible = true, raf = 0, offset = 37;
    function draw(now) {
      gl.uniform1f(uT, offset + (now - t0) / 1000);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    function loop(now) {
      raf = 0;
      if (!visible || document.hidden) return;
      draw(now);
      raf = requestAnimationFrame(loop);
    }
    function kick() { if (!raf && visible && !document.hidden) raf = requestAnimationFrame(loop); }

    reach();
    size();
    var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    draw(performance.now());
    canvas.classList.add('is-live');
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { size(); draw(performance.now()); }).observe(canvas);
      new ResizeObserver(reach).observe(document.body);
    }
    window.addEventListener('load', reach);
    if (still) return;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        kick();
      }).observe(canvas);
    }
    document.addEventListener('visibilitychange', kick);
    kick();
  }

  function init() {
    var nodes = document.querySelectorAll('[data-gene-sky]');
    for (var i = 0; i < nodes.length; i++) start(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
